import apiSlice from "./apiSlice";
const projectPermissionSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProjectPermission: builder.query({
            query: (req) => ({
                url: `RolePermission/GetPermissionsByProjectId`,
                params: req,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
    }),
});

export const {
    useGetProjectPermissionQuery,
    useLazyGetProjectPermissionQuery
} = projectPermissionSlice;
